import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amountDisplay", "amountInput"]
  static values = {
    budgetId: String,
    amount: Number,
    url: String
  }

  editAmount() {
    this.amountDisplayTarget.style.display = 'none'
    this.amountInputTarget.style.display = 'inline-block'
    this.amountInputTarget.value = (this.amountValue / 100).toFixed(2)
    this.amountInputTarget.focus()
    this.amountInputTarget.select()
  }

  saveAmount() {
    const newAmount = parseFloat(this.amountInputTarget.value)

    if (isNaN(newAmount) || newAmount === (this.amountValue / 100)) {
      this.cancelAmount()
      return
    }

    this.updateBudget({ amount_cents: newAmount })
  }

  cancelAmount() {
    this.amountInputTarget.style.display = 'none'
    this.amountDisplayTarget.style.display = 'inline'
  }

  updateBudget(params) {
    const formData = new FormData()
    if (params.amount_cents !== undefined) {
      formData.append('finance_budget[amount_cents]', params.amount_cents)
    }

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json'
      },
      body: formData
    })
    .then(response => {
      if (response.ok) {
        window.location.reload()
      } else {
        console.error('Error updating budget:', response.statusText)
        this.cancelAmount()
      }
    })
    .catch(error => {
      console.error('Error updating budget:', error)
      this.cancelAmount()
    })
  }
}

